class DataParser {
    static parse(rawData) {
        return ({
            id: parseInt(rawData.id),
            data: {
                model: rawData.data.model,
                brand: rawData.data.brand,
                questions: DataParser.parseQuestios(rawData.data.questions)
            }

        });
    }

    static parseQuestios(rawQuestions) {
        return rawQuestions.map((question) => {
            return({
                id: parseInt(question.id),
                title: question.title,
                description: question.description
            })
        })
    }
}


export default DataParser;



/** WEBPACK FOOTER **
 ** ./src/sources/parsers/DataParser.js
 **/